var _path, _path2, _path3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54694 12.456V15.0029L6.94286 12.456H12.0367C12.5062 12.456 12.8857 12.0765 12.8857 11.607V3.96617C12.8857 3.49668 12.5062 3.11719 12.0367 3.11719H1.84898C1.37949 3.11719 1 3.49668 1 3.96617V11.607C1 12.0765 1.37949 12.456 1.84898 12.456H3.54694Z",
    stroke: "#8A939A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24219 6.35938H9.28461",
    stroke: "#8A939A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24219 8.87891H7.48375",
    stroke: "#8A939A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3885,
    cy: 3.6112,
    rx: 3.46667,
    ry: 3.46667,
    fill: "#00AECC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkUnread);
export default __webpack_public_path__ + "static/media/mark-unread.b22bcddbd17d416e79b40efe37b77843.svg";
export { ForwardRef as ReactComponent };